import type { KpiSeverity, KpiThreshold, WeekKpi } from './types';

export const evaluateKpiSeverity = (value: number, threshold: KpiThreshold): KpiSeverity => {
  if (value > threshold.limit) return 'EXCEEDED';
  if (
    threshold.warningMargin !== undefined &&
    value >= threshold.limit - threshold.warningMargin
  ) {
    return 'WARNING';
  }
  return 'OK';
};

// Beds never escalate to WARNING: treatment plans are normally fully booked
// (e.g. 7/8 is expected). Only overbooking is a real problem, so bed resources
// without a warningMargin only contribute at EXCEEDED severity.
// Planning issues escalate to EXCEEDED because they're already rendered as red
// error tags in StatusRow — the corner warning icon should match.
export const aggregateWeekSeverity = (kpi: WeekKpi): KpiSeverity => {
  const anyExceeded =
    kpi.professions.some((p) => evaluateKpiSeverity(p.planned, p.threshold) === 'EXCEEDED') ||
    kpi.bedResources.some((b) => evaluateKpiSeverity(b.used, b.threshold) === 'EXCEEDED') ||
    kpi.planningIssues.length > 0;
  if (anyExceeded) return 'EXCEEDED';
  const anyWarning = kpi.professions.some(
    (p) => evaluateKpiSeverity(p.planned, p.threshold) === 'WARNING',
  );
  return anyWarning ? 'WARNING' : 'OK';
};
